// extracted by mini-css-extract-plugin
export var active = "index-module--active--sDya1";
export var divider = "index-module--divider--G1k+z";
export var steps = "index-module--steps--kDbJO";